/* globals dataLayer */
import $ from 'jquery';
import GaTracking from '../../../core/components/ga-tracking';
export default class CheckOutPaymentMethods {
    static init() {
        if ($('.js__payment-methods').length) {
            this.bindEvents();
        }
    }
    static bindEvents() {
        $('.js__payment-source-input').on('change', e => {
            const $currentTarget = $(e.currentTarget);
            const isOnlineChecked = $currentTarget.is(':checked');
            if (isOnlineChecked) {
                $currentTarget
                    .closest('.js__payment-source-wrapper')
                    .find('.js__online-payment-radio-btn')
                    .prop('checked', true);
            }
        });
        $('.js__method-radio-btn, .js__payment-source-input').on('change', e => {
            const $currentTarget = $(e.currentTarget);
            const option = $currentTarget.val();
            const isChecked = $currentTarget.is(':checked');
            if (isChecked) {
                GaTracking.pushDataLayer({
                    event: 'checkoutOption',
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 3,
                                option,
                            },
                        },
                    },
                });
            }
        });
    }
}
